import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Toolbar,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
} from '@material-ui/core';

import { lighten } from '@material-ui/core/styles/colorManipulator';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment';
import { dropRight, compact } from 'lodash';
import isMobile from 'ismobilejs';
import $ from 'jquery';

import { dateTimeFormat, shippingTimes, shippingStatus } from '../common/constants';

const onchangesArray = {
  shippingTimeValues: shippingTimes,
  shippingStatusValues: shippingStatus,
};
const ShowAll = 'Show All';
const ShowPending = 'Show Pending';
const ShowCancelled = 'Show Cancelled';
const CANCELLED_OPTION = 'cancelled';
const ITEM_HEIGHT = 70;
const ITEM_PADDING_TOP = 200;
const MIN_TYPED_CHARS = 4;

const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    width: 1000,
    flex: '1 1 100%',
    textAlignLast: 'left',
  },
  actions: {
    color: theme.palette.text.secondary,
    flex: '1 1 100%',
    textAlignLast: 'right',
  },
  title: {
    flex: '0 0 auto',
  },
  button: {
    margin: theme.spacing.unit,
    color: theme.palette.background.default,
    backgroundColor: '#4e91fd',
  },
  flex: {
    flex: 1,
  },
  toolbar: {
    backgroundColor: theme.palette.background.default,
    padding: 5,
  },
  icon: {
    margin: theme.spacing.unit,
  },
  input: {
    display: 'none',
  },

  formControl: {
    margin: theme.spacing.unit,
    minWidth: 150,
    maxWidth: isMobile.phone ? window.screen.width * 0.9 : '300px',
  },

  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
});

class EnhancedTableToolbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      query: '',
      shippingTimeValues: props.filters.shippingTime ? props.filters.shippingTime.split(',') : [],
      shippingStatusValues: [],
      ranges: {
        Today: [moment().startOf('day'), moment().endOf('day')],
        Yesterday: [
          moment()
            .subtract(1, 'days')
            .startOf('day'),
          moment()
            .subtract(1, 'days')
            .endOf('day'),
        ],
        'This Week': [
          moment()
            .startOf('week')
            .add(1, 'day'),
          moment()
            .endOf('week')
            .add(1, 'day'),
        ],
        'Last Week': [
          moment()
            .subtract(1, 'week')
            .startOf('week')
            .add(1, 'day'),
          moment()
            .subtract(1, 'week')
            .endOf('week')
            .add(1, 'day'),
        ],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [
          moment()
            .subtract(1, 'month')
            .startOf('month'),
          moment()
            .subtract(1, 'month')
            .endOf('month'),
        ],
        'Last 180 Days': [moment().subtract(180, 'day'), moment()],
      },
    };
    this.handleApply = this.handleApply.bind(this);
    this.handleUploadRequest = this.handleUploadRequest.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleClearDate = this.handleClearDate.bind(this);
    this.closeKeyboard = this.closeKeyboard.bind(this);
    this.handleSearchDebounce = this.handleSearchDebounce.bind(this);
  }

  componentDidMount() {
    $(document).ready(() => {
      $('input.form-control')
        .wrap('<span class="deleteicon" />')
        .after(
          $('<span/>').click(function() {
            $(this)
              .prev('input')
              .val('')
              .trigger('change')
              .focus();
          })
        );
    });
  }

  handleApply(event, picker) {
    let startDate = null;
    let endDate = null;
    if (picker.startDate._isValid) {
      startDate = picker.startDate.format(dateTimeFormat);
      endDate = picker.endDate.format(dateTimeFormat);
    }
    this.props.handleFilter({
      createdFrom: startDate,
      createdTo: endDate,
    });
  }

  handleClearDate() {
    this.props.handleFilter({
      createdFrom: null,
      createdTo: null,
    });
  }

  handleUploadRequest() {
    this.fileInput.value = null;
    this.fileInput.click();
  }

  handleChange = event => {
    if (event.target.value.indexOf(ShowAll) >= 0) {
      this.setState({ [event.target.name]: Object.keys(onchangesArray[event.target.name]) });
    } else if (event.target.value.indexOf(ShowPending) >= 0) {
      this.setState({ [event.target.name]: dropRight(Object.keys(shippingTimes), 1) });
    } else if (event.target.value.indexOf(ShowCancelled) >= 0) {
      this.setState({ [event.target.name]: [CANCELLED_OPTION] });
    } else {
      this.setState({ [event.target.name]: compact(event.target.value) });
    }
  };

  closeKeyboard(e) {
    if (e.keyCode === 13) {
      document.activeElement.blur();
    }
  }

  handleSearchDebounce({ target: { value } }) {
    if (!value || value.length >= MIN_TYPED_CHARS) {
      if (this.debouce) clearTimeout(this.debouce);
      this.debouce = setTimeout(
        () =>
          this.props.handleFilter({
            query: value,
          }),
        500
      );
    }
    this.setState({
      query: value,
    });
  }

  render() {
    const {
      classes,
      handleFilter,
      doExport,
      doImport,
      filters: { createdFrom, createdTo },
    } = this.props;
    const label = 'Created Date Range';
    let dateValue = '';
    if (createdFrom || createdTo) {
      dateValue = `${createdFrom}-${createdTo}`;
    }

    const locale = {
      format: dateTimeFormat,
      separator: ' - ',
      applyLabel: 'Apply',
      cancelLabel: 'Cancel',
      weekLabel: 'W',
      customRangeLabel: 'Custom Range',
      daysOfWeek: moment.weekdaysMin(),
      monthNames: moment.monthsShort(),
      firstDay: moment.localeData().firstDayOfWeek(),
    };
    const isCancelled = this.state.shippingTimeValues.toString() === CANCELLED_OPTION;
    return (
      <Toolbar className={classes.toolbar}>
        <div className={classes.spacer}>
          <span>Created Date: </span>
          <DateRangePicker
            timePicker
            showDropdowns
            autoApply
            locale={locale}
            ranges={this.state.ranges}
            onApply={(event, picker) => this.handleApply(event, picker)}
          >
            <div className="input-group">
              <input
                type="text"
                className="search-box"
                value={dateValue}
                placeholder={label}
                style={{ width: isMobile.phone ? window.screen.width * 0.9 : '303px' }}
              />
            </div>
          </DateRangePicker>
          {dateValue && (
            <button className="close-icon" type="reset" onClick={() => this.handleClearDate()} />
          )}

          <FormControl className={classes.formControl}>
            <InputLabel htmlFor="select-multiple-checkbox">Status</InputLabel>
            <Select
              name="shippingTimeValues"
              multiple
              value={this.state.shippingTimeValues}
              onChange={this.handleChange}
              renderValue={selected =>
                selected
                  .map(key => (isCancelled ? CANCELLED_OPTION : shippingTimes[key]))
                  .join(', ')
              }
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: ITEM_HEIGHT * 4 + ITEM_PADDING_TOP,
                    width: 250,
                    top: 130,
                  },
                },
                onExited: () =>
                  handleFilter({
                    shippingTime: this.state.shippingTimeValues.toString(),
                  }),
              }}
            >
              <MenuItem key={ShowAll} value={ShowAll}>
                <ListItemText primary={ShowAll} />
              </MenuItem>
              <MenuItem key={ShowPending} value={ShowPending}>
                <ListItemText primary={ShowPending} />
              </MenuItem>
              <MenuItem key={ShowCancelled} value={ShowCancelled}>
                <ListItemText primary={ShowCancelled} />
              </MenuItem>
              {isCancelled ? (
                <MenuItem key={CANCELLED_OPTION} value={CANCELLED_OPTION}>
                  <Checkbox checked disabled />
                  <ListItemText primary={CANCELLED_OPTION} />
                </MenuItem>
              ) : (
                Object.keys(shippingTimes).map(key => (
                  <MenuItem key={key} value={key}>
                    <Checkbox checked={this.state.shippingTimeValues.indexOf(key) > -1} />
                    <ListItemText primary={shippingTimes[key]} />
                  </MenuItem>
                ))
              )}
            </Select>
          </FormControl>
          <input
            ref={input => (this.input = input)}
            type="search"
            placeholder="Search here..."
            value={this.state.query}
            onKeyDown={e => this.closeKeyboard(e)}
            onChange={this.handleSearchDebounce}
            className="search-box"
            style={{ display: '', width: isMobile.phone ? window.screen.width * 0.9 : '303px' }}
          />
          <span className="float-right">
            <Button
              id="exportButton"
              variant="contained"
              size="small"
              className={classes.button}
              onClick={() => doExport()}
            >
              {/* <ImportExport className={classes.icon} /> */}
              Export
            </Button>
            <input
              accept="csv"
              className={classes.input}
              id="contained-button-file"
              type="file"
              ref={$ => {
                this.fileInput = $;
              }}
              onChange={doImport}
            />

            <Button
              id="importButton"
              size="small"
              className={classes.button}
              onClick={this.handleUploadRequest}
            >
              Import
            </Button>
          </span>
        </div>
      </Toolbar>
    );
  }
}

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  handleFilter: PropTypes.func.isRequired,
  doFilter: PropTypes.func.isRequired,
  doExport: PropTypes.func.isRequired,
  doImport: PropTypes.func.isRequired,
  doRest: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
};

export default withStyles(toolbarStyles)(EnhancedTableToolbar);



// WEBPACK FOOTER //
// ./src/components/orders/EnhancedTableToolbar.js